export enum Region {
    Global = "global",
    Asia = "asia",
}
